import React from "react"
import { Dropdown, Image, Row } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBook } from "@fortawesome/free-solid-svg-icons"
import { Storage } from "../Storage"
import { Notificaciones, notify } from "../Model/Notificaciones"
import { auth } from "../database/Auth"
import { users } from "../database/Users"
import { zfill } from "../Utils/Formats"
import Seguimientos from "../app/Cotizacion/Seguimientos"
import { UpdateElement } from "../Utils/ArrayFun"
import { toast } from "react-toastify"
interface State {
    notificaciones: notify[]
    cont: number
    bitacora: number
    open: boolean
}
class Notify extends React.Component<notify & { select: (chat: number) => void }>{
    render() {
        let { props: { select, quotation_id, msn, user_id } } = this,
            user = users().getUser(user_id)
        return <Dropdown.Item className="d-flex align-items-center">
            <div onClick={() => { select(quotation_id) }} className="dropdown-list-image mr-3">
                <Image width="60" height="60" roundedCircle src={user.image} alt="" />
            </div>
            <div onClick={() => { select(quotation_id) }} style={{ width: 180 }} className="font-weight-bold">
                <div className="text-truncate">{user.name}</div>
                <div className="small float-right">{zfill(quotation_id)}</div>
                <div style={{ maxWidth: 180, whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }} className="small">{msn}</div>
            </div>
        </Dropdown.Item>
    }
}
class Mensajes extends React.Component<any, State> {
    con = Notificaciones(auth().id)
    constructor(p: any) {
        super(p)
        this.state = { cont: 0, notificaciones: [], bitacora: 0, open: false }
        this.setState = this.setState.bind(this)
    }
    render() {
        let height = window.innerHeight / 2
        let { bitacora, open } = this.state;
        return <Dropdown as="li" className="nav-item no-arrow mx-1">
            <Dropdown.Toggle className="nav-link" as="div">
                {bitacora > 0 ? open ? <Seguimientos open={open} id={bitacora}
                    close={() => { this.setState({ open: false, bitacora: 0 }) }} /> : <></> : <></>}
                <FontAwesomeIcon onClick={() => { this.setState({ cont: 0 }) }} icon={faBook} />
                {this.state.cont > 0 ?
                    <span className="badge badge-danger badge-counter">{this.state.cont}</span> : <></>}
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight className="dropdown-list dropdown-menu p-0 shadow animated--grow-in">
                <Dropdown.Header className="bg-warning border-warning" as="h6">Ultimos registros</Dropdown.Header>
                <div style={{ height, overflowY: "scroll" }}>
                    {this.getNotificaciones()}
                </div>
                <Dropdown.Item href="#/action-1" className="text-center small text-gray-500">Ultimos registros</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    }
    componentDidMount() {
        this.start();
    }
    start() {
        if (this.con.id !== 0) {
            if (this.state.notificaciones.length === 0) {
                this.con.updateCotizacion(this.setData.bind(this));
            } else {
                this.con.setCotizacion(this.setLimpia.bind(this));
                setTimeout(() => { this.start(); }, 108000000);
            }
        } else {
            setTimeout(() => {
                this.start();
            }, 500);
        }
    }
    updateNotifi(n: notify) {
        n.read = 2;
        this.setState({ notificaciones: UpdateElement({ a: this.state.notificaciones, b: n, label: "id" }) });
        let user = users().getUser(n.user_id)
        toast(<Row onClick={() => { this.select(n.quotation_id) }} className="px-2">
            <div className="dropdown-list-image mr-3">
                <Image width="60" height="60" roundedCircle src={user.image} alt="" />
            </div>
            <div style={{ width: 180 }} className="font-weight-bold">
                <div className="text-truncate">{user.name}</div>
                <div className="small float-right">{zfill(n.quotation_id)}</div>
                <div style={{ maxWidth: 180, whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }} className="small">{n.msn}</div>
            </div>
        </Row>, { type: toast.TYPE.WARNING })
    }
    setData(d: notify[]) {
        this.setState({
            notificaciones: [...this.state.notificaciones, ...d].sort((a, b) => {
                return (b.id - a.id)
            })
        });
    }
    setLimpia(d: notify[]) {
        this.setState({
            notificaciones: d.sort((a, b) => {
                return (b.id - a.id)
            })
        });
    }
    select(bitacora: number) {
        this.setState({ bitacora, open: true })
    }
    getNotificaciones() {
        let { notificaciones } = this.state
        return notificaciones.map((m: notify) => {
            if (m.read !== 2)
                this.updateNotifi(m);
            return <Notify select={this.select.bind(this)} key={"bitacora" + m.id} {...m} />
        })
    }
}
Mensajes.contextType = Storage
export default Mensajes
